import {
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Checkbox,
  Chip,
  Box,
  FormControl,
  Typography,
} from "@mui/material";
import React from "react";
import "./ReusableCheckboxSelect.css";

const ReusableCheckboxSelect = ({
  name,
  touched,
  errors,
  selected,
  data,
  handleChange,
  setFieldValue,
  setFieldTouched,
  userDetails,
  setUserDetails,
}) => {
  // Define dependencies between permissions
  const permissionDependencies = {
    manageGuests: "accessToMobile",
    // accessToReports: "accessToCms",
  };

  const handleSelect = (event) => {
    const { value } = event.target;

    // Get all selected permission IDs
    const selectedPermissions = new Set(value);

    // Add dependent permissions
    value.forEach((id) => {
      const selectedPermission = data.find((item) => item.permissionId === id);
      if (selectedPermission) {
        const dependentPermissionName =
          permissionDependencies[selectedPermission.permissionName];
        if (dependentPermissionName) {
          const dependentPermission = data.find(
            (item) => item.permissionName === dependentPermissionName
          );
          if (dependentPermission) {
            selectedPermissions.add(dependentPermission.permissionId);
          }
        }
      }
    });

    // Convert Set to Array and update state
    const updatedSelected = Array.from(selectedPermissions);
    setUserDetails((prev) => ({
      ...prev,
      permission: data.filter((item) =>
        updatedSelected.includes(item.permissionId)
      ),
    }));

    setFieldValue(
      name,
      data.filter((item) => updatedSelected.includes(item.permissionId))
    );
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      size="small"
      error={touched.permission && Boolean(errors.permission)}
    >
      <InputLabel id={`${name}-label`}>Permission</InputLabel>
      <Select
        labelId={`${name}-label`}
        multiple
        value={selected?.map((item) => item.permissionId)}
        onChange={handleSelect}
        onBlur={() => setFieldTouched("permission", true)}
        input={<OutlinedInput label={name} />}
        disabled={userDetails?.roleId === 3}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected?.map((id) => {
              const item = data.find(
                (dataItem) => dataItem.permissionId === id
              );
              if (!item) {
                console.warn(`No data found for permissionId: ${id}`);
                return null;
              }
              return (
                <Chip
                  key={id}
                  label={item.permissiondisplayName}
                  size="small"
                />
              );
            })}
          </Box>
        )}
      >
        {data.map((item) => (
          <MenuItem key={item.permissionId} value={item.permissionId}>
            <Checkbox
              checked={selected.some(
                (s) => s.permissionId === item.permissionId
              )}
            />
            <ListItemText primary={item.permissiondisplayName} />
          </MenuItem>
        ))}
      </Select>
      {touched.permission && errors.permission && (
        <Typography
          variant="body2"
          color="error"
          sx={{
            fontSize: "0.75rem",
            marginTop: "4px",
            marginLeft: "10px",
            color: "#d32f2f",
            fontFamily: "Lato, sans-serif",
          }}
        >
          {errors.permission}
        </Typography>
      )}
    </FormControl>
  );
};

export default ReusableCheckboxSelect;
